<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-[80vw] h-[90vh]"
  data-testid="subcriteria-attribute-scores-modal"
>
  <ng-template #header>
    <div class="flex flex-col gap-1 w-full">
      <h2 class="text-xl font-semibold m-0">
        {{ 'project.steps.providerResults.subcriteriaAttributes.title' | transloco }}
      </h2>
      @if (subcriteriaLabel()) {
        <span class="text-base text-gray-500">{{ subcriteriaLabel() }}</span>
      }
    </div>
  </ng-template>

  <div class="flex justify-end items-end mb-4 flex-wrap gap-4">
    <app-subcriteria-attribute-scores-provider-filter
      [providers]="providerColumns()"
      [selectedProviderIds]="selectedProviderIdsList()"
      (selectedProviderIdsChange)="onSelectedProvidersChange($event)"
    />
    <p-selectButton
      [options]="viewOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="viewMode"
      data-testid="subcriteria-attribute-scores-view-selector"
    >
      <ng-template #item let-item>
        <span class="flex items-center gap-2">
          {{ item.translationKey | transloco }}
          <i [class]="item.value === 'table' ? 'pi pi-table' : 'pi pi-map'"></i>
        </span>
      </ng-template>
    </p-selectButton>
  </div>

  @if (viewMode() === 'table') {
    <app-subcriteria-attribute-scores-table
      [rows]="attributeRows()"
      [providers]="filteredProviders()"
    />
  } @else {
    <app-subcriteria-attribute-scores-heatmap
      [rows]="attributeRows()"
      [selectedProviders]="filteredProviders()"
      [allProviders]="providerColumns()"
      [isExponentialScale]="isExponentialScale()"
    />

    <!-- Legend -->
    <div class="flex justify-center gap-6 mt-4">
      <div class="flex items-center gap-2">
        <div class="w-3 h-3 bg-(--color-red)"></div>
        <span class="text-sm">{{
          'project.steps.providerResults.heatmap.legend.red' | transloco
        }}</span>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-3 h-3 bg-(--color-yellow)"></div>
        <span class="text-sm">{{
          'project.steps.providerResults.heatmap.legend.yellow' | transloco
        }}</span>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-3 h-3 bg-(--color-green)"></div>
        <span class="text-sm">{{
          'project.steps.providerResults.heatmap.legend.green' | transloco
        }}</span>
      </div>
    </div>
  }
</p-dialog>
